// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__tDWVi","link":"modal_link__H68Ue"};